















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { EventLogsObjectType, EventLogActions } from '@/modules/shared/eventlogs/enums';

@Component({
    components: {
    },
})
export default class SaveBar extends Vue {
    @Prop({required: false})
    public saving!: boolean;

    private leftPosition: number = 0;

    private save() {
        this.$emit('save');
    }

    private mounted() {
        if (document) {
            const bar = document.getElementById('savebar');

            if (bar) {
                const rect = bar.getBoundingClientRect();
                this.leftPosition -= rect.left;
            }
        }
    }
}
